import {Fieldset, Text} from '@albert-io/atomic';
import React from 'react';

interface AnswerFieldsetProps {
  /** The line above the answer. It is the fieldset's legend, so screen readers read it with the question. */
  instruction: string;
  /** The line goes away once the student submits. */
  isSubmitted: boolean;
  children: React.ReactNode;
}

/** The answer area of an item-bank or ordering question, introduced by its instruction line. */
export const AnswerFieldset = ({instruction, isSubmitted, children}: AnswerFieldsetProps) => (
  <Fieldset className='min-w-x0'>
    {!isSubmitted && (
      <Text as='legend' size='s' color='secondary' className='mb-x2'>
        {instruction}
      </Text>
    )}
    {children}
  </Fieldset>
);
